import { render, staticRenderFns } from "./BulkFilePage.vue?vue&type=template&id=08831eb1&"
import script from "./BulkFilePage.vue?vue&type=script&lang=ts&"
export * from "./BulkFilePage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkFilePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports